import axios from 'axios';
import {getToken} from '../utils/auth';
import {hasProperty} from '../utils/hasProperty';
import {checkDetails} from '../utils/checkDetails';

const {CancelToken} = axios;
const apiUrl = process.env.REACT_APP_API_URL;
let cancel;

const getParams = () =>
    getToken()
        ? {
            baseURL: apiUrl,
            headers: {Authorization: getToken()},
        }
        : {
            baseURL: apiUrl,
        };

const api = axios.create(getParams());

api.interceptors.request.use(
    async (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

api.interceptors.response.use(
    (response) => {
        if (cancel) {
            cancel(); // cancel request
        }

        response.cancelToken = new CancelToken(function executor(c) {
            cancel = c;
        });

        return response;
    },
    (error) => {
        try {
            const status = hasProperty(error, 'response') ? error.response.status : error;
            switch (status) {
                case 401:
                    checkDetails(error.response.data.detail);
                    break;
                case 403:
                    if (error.response.data['hydra:description']) {
                        checkDetails(error.response.data['hydra:description']);
                    } else {
                        checkDetails('');
                    }
                    break;
                case 404:
                    console.error(`Error ${status}`);
                    break;
                case 405:
                case 406:
                case 422:
                default:
                    console.error(`Error ${status}`);
            }
        } catch (e) {
            window.location = `${window.location.origin}/erros`;
        }
        return Promise.reject(error);
    },
);
export default api;
